module.exports = __webpack_public_path__ + "static/context-map-train-booking-8a8b752a6427294131b80e609e60c2dd.png";